import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="custom-radio"
export default class extends Controller {
  connect() {
    // This removes any existing custom elements to avoid duplicates
    this.element.querySelectorAll('span.customradio').forEach(el => el.remove());
    
    let radios = this.element.querySelectorAll('input[type=radio]');
    
    const radioSpan = '<span class="customradio"></span>';
  
    radios.forEach(radio => {
      if (!radio.nextElementSibling || !radio.nextElementSibling.classList.contains('customradio')) {
        radio.insertAdjacentHTML('afterend', radioSpan);
      }
    });
  }
}
